import { createContext, useState } from 'react';

export const SmallSignUpContext = createContext();

const SmallSignUpContextProvider = ({ children }) => {

    const [jobId, setJobId] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    
    const openPopUp = (id = '') => {
        setJobId(id);
        setShowPopUp(true);
    };
    const closePopUp = () => {
        setJobId('');
        setShowPopUp(false);
    };

    return <SmallSignUpContext.Provider
        value={{
            jobId,
            showPopUp,
            setShowPopUp,
            openPopUp,
            closePopUp
        }}>
        {children}
    </SmallSignUpContext.Provider>
};


export default SmallSignUpContextProvider;